export default {
  emits: ['resendPhoneToken'],

  methods: {
    onSendTokenBtnClick() {
      this.$emit('resendPhoneToken');
    },
  },
};
